import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { appTranslate } from '../../i18n';
import { SECTION_IDS } from '../../../consts';
import { useBI, useImpression, SECTION_NAMES } from '../../bi';

gsap.registerPlugin(useGSAP, SplitText, ScrollTrigger);

export const IntroSection = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const paraRef = useRef<HTMLElement>(null);
    const bi = useBI();
    const impressionRef = useImpression<HTMLDivElement>(() =>
        bi.reportSectionImpression({ sectionName: SECTION_NAMES.intro })
    );

    const setRootNode = (node: HTMLDivElement | null) => {
        wrapperRef.current = node;
        (impressionRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
    };

    useGSAP(
        () => {
            const split = new SplitText(paraRef.current, { type: 'words' });

            gsap.to(split.words, {
                color: theme.colors.black,
                ease: 'none',
                stagger: 0.1,
                scrollTrigger: {
                    trigger: wrapperRef.current,
                    start: 'top top',
                    end: 'bottom bottom',
                    scrub: 0.5,
                },
            });
        },
        { scope: wrapperRef }
    );

    return (
        <Container ref={setRootNode} height="160vh" id={SECTION_IDS.intro}>
            <Container
                as="section"
                position="sticky"
                top={0}
                height="100vh"
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                paddingX="12"
            >
                <Container maxWidth="924px">
                    <Typography
                        ref={paraRef}
                        as="p"
                        fontWeight="light"
                        color="grey_600"
                        textAlign="center"
                        letterSpacing="-0.06em"
                        style={{ fontSize: 'clamp(24px, 4vw, 48px)', lineHeight: 1.2 }}
                    >
                        {appTranslate('intro.body_part_1')}
                        <br />
                        <br />
                        {appTranslate('intro.body_part_2')}
                    </Typography>
                </Container>
            </Container>
        </Container>
    );
};
